
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setErrorFlag } from '../../store/slices/errorConfig';

export const SomeThingWentWrong = (data:any) => {
    const dispatch = useDispatch();
    const [isClosing, setIsClosing] = useState(false);

    const closeErrorPop = () =>{
         dispatch(setErrorFlag({isError:false, errorMsg: ''}));
    }

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            closeErrorPop();
        }, 500); // Animation duration
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            handleClose();
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    const toastStyle: React.CSSProperties = {
        position: 'fixed',
        top: '20px',
        left: '20px',
        right: '20px',
        textAlign: 'left',
        transform: 'translateY(10%)',
        background: 'rgba(0,0,0,0.8)',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 100,
        display: 'flex',
        color:'#fff',
        alignItems: 'center',
        animation: isClosing ? 'slideOut 0.5s forwards' : 'slideIn 0.5s forwards',
    };

    const closeIconStyle: React.CSSProperties = {
        marginLeft: '16px',
        cursor: 'pointer',
        width: '16px',
        height: '16px'
    };

    return (
        <>
            <style>
                {`
                    @keyframes slideIn {
                        from { top: -100px; opacity: 0; }
                        to { top: 20px; opacity: 1; }
                    }
                    @keyframes slideOut {
                        from { top: 20px; opacity: 1; }
                        to { top: -100px; opacity: 0; }
                    }
                `}
            </style>
            <div style={toastStyle}>
                {data.errorMsg}
                <svg onClick={handleClose} style={closeIconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
        </>
    )
}